// extracted by mini-css-extract-plugin
export var simpleView = "recipe-preparation-steps-module--simple-view--atM+P";
export var stepItem = "recipe-preparation-steps-module--step-item--4-xcM";
export var stepList = "recipe-preparation-steps-module--step-list--JDckt";
export var steps = "recipe-preparation-steps-module--steps--mtxzG";